/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import React from 'react';
import { checkIsSubMenu, checkIsMenuGroup } from './checkMenuType.js';
import './type.js';

var getSubMenuChildCount = function getSubMenuChildCount(children) {
  var count = 0;
  React.Children.forEach(children, function (child) {
    if (checkIsSubMenu(child) || checkIsMenuGroup(child)) {
      count += getSubMenuChildCount(child.props.children) + 1;
    } else {
      count += 1;
    }
  });
  return count;
};
var MENU_ITEM_HEIGHT = 50;
var getSubMenuMaxHeight = function getSubMenuMaxHeight(children) {
  return getSubMenuChildCount(children) * MENU_ITEM_HEIGHT;
};

export { getSubMenuChildCount, getSubMenuMaxHeight };
//# sourceMappingURL=getSubMenuChildStyle.js.map
